import { css } from '@emotion/react';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';

export const legalContainerStyles = css({
  width: '40%',
  height: '100%',
  margin: '0 auto',
  textAlign: 'center',
  padding: theme.spacing(2, 0, 8),
});

export const legalCardStyles = css({
  marginTop: theme.spacing(2),
  padding: theme.spacing(2),
  boxSizing: 'border-box',
  backgroundColor: theme.colors.white,
  borderRadius: theme.borderRadius.medium,
  boxShadow: theme.shadows.floating,

  [`@media (max-width: ${breakpoints.medium.min}px)`]: {
    width: '80%',
  },
});

export const legalTextStyles = css({
  maxWidth: '100%',
  '.editor-root .editor-scroller': {
    resize: 'none',
  },
});

export const errorStyles = css({
  textAlign: 'center',
  padding: theme.spacing(2),
  color: theme.colors.neutral40,
});

export const imageStyle = css({
  maxHeight: 85,
  objectFit: 'contain',
  maxWidth: '100%',
});
